var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgTopazGemOutline = function SvgTopazGemOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 728 728",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M222.75 89L456.25 25L583.25 203L629.75 454.5L382.75 703L128.25 490L98.25 326L222.75 89Z",
    fill: "currentColor"
  })));
};
var Memo = /*#__PURE__*/memo(SvgTopazGemOutline);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/status/topaz-gem-outline.c74666c57dbbe450a82de067b24cd3d6.svg";